import React from 'react';

import { SanitizedOrder } from '../../../../../types/order/Order';

import OrderAmountPaid from './OrderAmountPaid';
import OrderAmountNeeded from './OrderAmountNeeded';
import OrderBillingAddress from './OrderBillingAddress';
import OrderCouponCodes from './OrderCouponCodes';
import OrderExtraShippingAddresses from './OrderExtraShippingAddresses';
import OrderPaymentMethod from './OrderPaymentMethod';
import OrderPoNumber from './OrderPoNumber';
import OrderReference from './OrderReference';
import OrderShippingCosts from './OrderShippingCosts';
import OrderTaxPortions from './OrderTaxPortions';
import OrderTimedDeliveries from './OrderTimedDeliveries';
import OrderTotal from './OrderTotal';
import OrderTotalNoVat from './OrderTotalNoVat';
import OrderTotalLineItems from './OrderTotalLineItems';
import CancelOrderButton from '../OrderActions/CancelOrder/CancelOrderButton';
import DownloadInvoiceButton from '../OrderActions/DownloadInvoice/DownloadInvoiceButton';
import useReOrder from '../../shared/Actions/ReOrderAction/useReOrder';
import OpenReOrderModalButton from '../../shared/Actions/ReOrderAction/OpenReOrderModalButton';
import PayOrderButton from '../../shared/Actions/PayOrder/PayOrderButton';
import OrderDiscountSummary from './OrderDiscountSummary';
import OrderServicesPriceSummary from './OrderServicesPriceSummary';

interface OrderSummaryProps {
  order: SanitizedOrder;
}

const OrderSummary = ({ order }: OrderSummaryProps) => {
  const canReOrder = useReOrder(order.lineItems, order, true);

  return (
    <div className="pd-flex pd-flex-col pd-gap-3 pd-rounded pd-border pd-p-3 pd-text-sm">
      <OrderBillingAddress order={order} />
      <OrderReference order={order} />
      <OrderPoNumber order={order} />
      <OrderPaymentMethod order={order} />
      <hr className="pd-my-1" />
      <OrderTotalLineItems order={order} />
      <OrderServicesPriceSummary order={order} />
      <OrderShippingCosts order={order} />
      <OrderTimedDeliveries order={order} />
      <OrderExtraShippingAddresses order={order} />
      <OrderDiscountSummary order={order} />
      <OrderCouponCodes order={order} />
      <hr className="pd-my-1" />
      <OrderTotalNoVat order={order} />
      <OrderTaxPortions order={order} />
      <OrderTotal order={order} />
      <OrderAmountPaid order={order} />
      <OrderAmountNeeded order={order} />
      <hr className="pd-my-1" />
      <div className="pd-flex pd-flex-col pd-gap-4 md:pd-flex-row-reverse md:pd-items-center">
        <div className="pd-text-right">
          <PayOrderButton order={order} eventName="start_payment_bottom" />
        </div>
        <div className="pd-flex pd-grow pd-gap-4">
          { canReOrder.enabled && <OpenReOrderModalButton lineItems={order.lineItems} order={order} />}
          <CancelOrderButton order={order} />
          <DownloadInvoiceButton order={order} />
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
